export class ItemsFilterInfo {
    searchTerm: string | null;
    categoryIds: number[] | null;
    itemTypeIds: number[] | null;
}
